<template>
  <div class="page">
    <div class="header">
      <img
        class="logo"
        src="../assets/images/logo.png"
        alt=""
        @click="goBack()"
      />
      <img
        class="close"
        src="../assets/images/homeH5/close.png"
        alt=""
        @click="goBack()"
      />
    </div>
    <div class="container">
      <!-- <h1>{{ title }}</h1> -->
      <div style="overflow: auto" ref="content" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import { getArticleDetail } from '../global/api/api'

export default {
  data() {
    return {
      id: this.$route.query.id,
      title: '',
      content: ''
    }
  },
  mounted() {
    this.getArticle()
  },
  methods: {
    getArticle() {
      getArticleDetail(this.id).then((res) => {
        if (res.code === 0) {
          this.title = res.data.title
          this.content = res.data.content
          //this.$refs.content.scrollTop = 0
        }
      })
    },
    goBack() {
      this.$router.push({
        path: '/home'
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.page {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: #000;
  overflow: hidden;
}

/* PC端 */
@media screen and (min-width: 769px) {
  @import '../assets/css/article_pc.less';
}

/* 移动端  */
@media screen and (max-width: 769px) {
  @import '../assets/css/article_m.less';
}
</style>
